const faqs = [
  {
    q: '成全影院需要注册才能观看吗？',
    a: '不需要。成全影院所有内容完全免费，无需注册登录即可在线观看最新电影、新剧和热门综艺，打开即看，方便快捷。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '成全影院采用多线路CDN加速和智能画质自适应技术，可根据您的网络状况自动匹配最优清晰度。如遇卡顿，可尝试切换播放线路或选择较低清晰度，通常4G/WiFi环境下均可流畅播放。',
  },
  {
    q: '更新速度有多快？新剧什么时候上线？',
    a: '成全影院与各大平台同步更新，热门新剧通常播出后2小时内上线，院线电影下映后最快一周内收录。综艺节目当日更新，确保您不错过任何精彩内容。',
  },
  {
    q: '支持哪些设备观看？',
    a: '成全影院全面适配电脑、平板和手机端，无需下载APP即可在浏览器中直接观看。同时支持投屏到电视，让您在大屏幕上享受高清观影体验，随时随地想看就看。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary-400 mb-3">FAQ</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">常见问题</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">关于成全影院的常见疑问，这里为您一一解答</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px] mx-auto">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/40 hover:border-primary-500/20 transition-all duration-300">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-3 flex items-start gap-3">
                  <span className="text-primary-400 mt-0.5 flex-shrink-0">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed pl-7">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}